import axiosService from "./axios-service";

export const getProducts = async (product = "all") => {
  return axiosService.get(`/sales/incentive/fetch_product?product=${product}`);
};

export const addProduct = async (data) => {
  return axiosService.post(`/sales/incentive/upsert_product`, data);
};

export const uploadProductFile = (data) => {
  return axiosService.post(`/sales/incentive/v2/upsert_product`, data);
};
